
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-syllabus/tnpsc-syllabus",
      function () {
        return require("private-next-pages/tnpsc-syllabus/tnpsc-syllabus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-syllabus/tnpsc-syllabus"])
      });
    }
  